import React from 'react';
import { AutocompleteProps, createFilterOptions } from '@material-ui/lab';
import { Box, makeStyles } from '@material-ui/core';

import { ITag } from '../PersonProfile/interfaces';
import { CustomTheme } from 'common/ui/interfaces';
import Autocomplete from '../Autocomplete/Autocomplete';

interface IProps extends AutocompleteProps<any, any, any, any> {
  className?: string;
  onChange?: (e: any, arrTags: Array<Partial<ITag>>) => void;
  optionLabelProp?: 'name' | 'title';
}

const useStyles = makeStyles((theme: CustomTheme) => ({
  wrapper: {
    position: 'relative',
    width: '100%',

    '& .MuiAutocomplete-popper': {
      background: '#fff',
      '& .MuiAutocomplete-paper': {
        margin: 0,
      },
    },

    '& .MuiAutocomplete-tag': {
      backgroundColor: theme.palette.text.secondary,
      color: theme.palette.primary.contrastText,
    },
  },
}));

const CustomAutocomplete = ({
  multiple,
  id,
  options,
  value,
  renderInput,
  onBlur,
  onChange,
  className,
  optionLabelProp,
}: IProps): JSX.Element => {
  const classes = useStyles();

  const filter = createFilterOptions();

  return (
    <Box className={classes.wrapper}>
      <Autocomplete
        className={className}
        multiple={multiple}
        disableCloseOnSelect={multiple}
        id={id}
        options={options}
        getOptionLabel={option => (optionLabelProp ? option[optionLabelProp] : '')}
        value={value}
        renderInput={renderInput}
        onBlur={onBlur}
        onChange={(e, newValue) => {
          if (onChange) {
            onChange(
              e,
              newValue.map(tag => {
                if (typeof tag === 'string' && optionLabelProp) {
                  return { [optionLabelProp]: tag };
                }

                if (tag.inputValue && optionLabelProp) {
                  return { [optionLabelProp]: tag.inputValue };
                }

                return tag;
              }),
            );
          }
        }}
        fullWidth
        disablePortal
        filterOptions={(autocompleteOptions, params) => {
          const filtered = filter(autocompleteOptions, params);

          // Suggest the creation of a new value
          if (params.inputValue !== '' && optionLabelProp) {
            filtered.push({
              inputValue: params.inputValue,
              [optionLabelProp]: `Add "${params.inputValue}"`,
            });
          }
          return filtered;
        }}
        freeSolo
      />
    </Box>
  );
};

CustomAutocomplete.defaultProps = {
  optionLabelProp: 'name',
};

export default CustomAutocomplete;
